export const dummyCardLife = {
  error: false,
  data: {
    list: [
      {
        authorId: 5849216,
        authorName: "10년째수의사",
        blogId: 5931403,
        blogTitle: "수의사가 알려주는 반려동물 생활 속 꿀팁",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/5931403/attach/b0ae2c3ad9cf43e0a6aaf9c254728bfe",
        blogUrl: "https://vetstory.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/ATXC4/btsBqZXSQBv/6jHfw85KuYxvSXsmg8eeI1/img.png",
        entryId: 421,
        entryTitle: "아기들과 강아지/고양이 함께 지내도 되나요?(#신생아)",
        entryUrl:
          "https://vetstory.tistory.com/entry/%EC%95%84%EA%B8%B0%EB%93%A4%EA%B3%BC-%EA%B0%95%EC%95%84%EC%A7%80%EA%B3%A0%EC%96%91%EC%9D%B4-%ED%95%A8%EA%BB%98-%EC%A7%80%EB%82%B4%EB%8F%84-%EB%90%98%EB%82%98%EC%9A%94%EC%8B%A0%EC%83%9D%EC%95%84",
        entrySummary:
          "어린 아가들과 반려 동물이 함께 사는 것에는 장점과 단점이 있습니다. 어느 방식이 더 좋은 지는 보호자분이 직접 선택해야 합니다. 그 선택에 조금이나마 도움을 드리고자 글을 적겠습니다. 아기들과 강아지/고양이 함께 지내도 될까요? 안녕하세요~! 오늘은 어린 아가들과 강아지/고양이가 함께 지내도 되는지에 대하여 이야기하겠습니다. 저희가 결혼하고 양가 어르신들은 아이를 가지면 라이카와 리코를 어떻게 할 지에 대해 문의하셨습니다. 저희는 당연히 아이가 태어나더라도 같이 살 생각이었습니다. 하지만, 어르신들은 여러 가지 이유로 강아지와 어린 아기가 함께 자라는 건 좋지 않다고 하셨습니다. 물론, 저희의 생각은 달랐습니다. 오히려 어린 아기가 강아지나 고양이와 어린 시절을 보내면 건강적인 측면이나 심리적인 측면 ..",
        serviceCategoryName: "반려동물",
        reactionCount: 287,
        commentCount: 338,
        entryPublished: "2023-12-06T09:00:38+09:00",
        firstReactionCreated: "2024-06-11T15:12:41.228748+09:00",
        isSupportBlog: true,
        supportCount: 11,
        supporters: [
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
          {
            blogImage:
              "https://t1.daumcdn.net/tistory_admin/blog/admin/profile.gif",
          },
        ],
      },
      {
        authorId: 4289276,
        authorName: "RICH-FRUIT-",
        blogId: 4277724,
        blogTitle: "리치프룻",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/4277724/attach/59ca43f464dd41b699f3573d704ef223",
        blogUrl: "https://rich-fruit.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/cKtSqL/btsHUd39Uww/AMAGwMI9clCG1KsJbCgq41/img.png",
        entryId: 359,
        entryTitle: "가족 지인 선처 탄원서 쓰는법 양식 예문",
        entryUrl:
          "https://rich-fruit.tistory.com/entry/%EA%B0%80%EC%A1%B1-%EC%A7%80%EC%9D%B8-%EC%84%A0%EC%B2%98-%ED%83%84%EC%9B%90%EC%84%9C-%EC%93%B0%EB%8A%94%EB%B2%95-%EC%96%91%EC%8B%9D-%EC%98%88%EB%AC%B8",
        entrySummary:
          "변호사가 탄원서를 쓰라고 하는데, 어떻게 써야 할지 막막하신가요? 아래 방법을 보고 쓰시면 탄원서를 어렵지 않게 작성하실 수 있습니다. 아래에서 쉽게 알려드리겠습니다. 목차    가족과 지인의 선처 탄원서를 쓰는 방법과 양식, 예문을 알려드립니다.    가족 지인 선처 탄원서 쓰는 방법 및 양식 예문탄원서란 국가나 공공기관에 자신 혹은 주위 사람의 사정을 호소하면서 선처해 주기를 바라는 내용을 담은 문서입니다. 반대로 엄벌을 요청하는 진정서도 있습니다만, 오늘은 탄원서에 대해서만 다뤄보도록 하겠습니다.    기본적인 가족 지인 탄원서 쓰는 방법보통 범죄에 연루된 가족과 지인의 선처를 바라며 탄원서를 씁니다. 받는 대상은 공공기관(판사, 검사)입니다. 육하원칙에 따라서 작성하여야 하며, 핵심적인 사항을 진..",
        serviceCategoryName: "생활정보",
        reactionCount: 0,
        commentCount: 0,
        entryPublished: "2024-06-10T23:10:49+09:00",
        firstReactionCreated: "2024-06-11T15:12:41.245846+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
      {
        authorId: 6221095,
        authorName: "80퍼센트",
        blogId: 6387433,
        blogTitle: "주식 매매일지",
        blogImage:
          "https://tistory1.daumcdn.net/tistory/6387433/attach/fa65ddd27a5540599cd5a992e6d7ee55",
        blogUrl: "https://stock0901.tistory.com",
        entryThumbnail:
          "https://blog.kakaocdn.net/dn/UGgWh/btsHTlN8Utn/scWkgp0OzFzgJIYH0opnaK/img.webp",
        entryId: 410,
        entryTitle: "마하 프레임 타미야 FM-A 섀시 18714 구매처",
        entryUrl:
          "https://stock0901.tistory.com/entry/%EB%A7%88%ED%95%98-%ED%94%84%EB%A0%88%EC%9E%84-%ED%83%80%EB%AF%B8%EC%95%BC-FM-A-%EC%84%80%EC%8B%9C-18714-%EA%B5%AC%EB%A7%A4%EC%B2%98",
        entrySummary:
          "타미야 마하 프레임은 미니카 디자인 콘테스트 메리트 어워즈 수상한 혁신적인 제품으로, 2019년 출시 이후 많은 사랑을 받고 있습니다. 24년 현재까지도 일반판 제품 구하기 어려울 정도로 미니사구 매니아들의 큰 사랑을 받고 있는데요. 어렵게 구한 FM-A 섀시 마하 프레임 조립 해 보았습니다.   목차마하 프레임 18714마하 프레임 조립마하 프레임 실물 마하 프레임 187142018년 디자인 콘테스트 메리트 어워즈 수상한 제품으로 츠루타 히데유키가 디자인한 제품입니다. 츠루타 히데유키의 다양한 작품은 그의 인스타그램을 통해서도 확인하실 수 있습니다. 하단 이미지 누르면 Hideyuki Tsuruta 인스타그램 계정으로 이동합니다.(다수의 작품 구경 가능해요)  이름에서 알 수 있듯이 공기역학적 디자인을..",
        serviceCategoryName: "일상다반사",
        reactionCount: 4,
        commentCount: 3,
        entryPublished: "2024-06-10T11:39:53+09:00",
        firstReactionCreated: "2024-06-11T15:12:41.252262+09:00",
        isSupportBlog: true,
        supportCount: 0,
        supporters: [],
      },
    ],
    category: "life",
    hasNext: false,
  },
};

export const dummyItemLife = {
  error: false,
  data: {
    lastPublished: 1718081932000,
    list: [
      {
        uniqueId: "3282011_309",
        title:
          "여름철에는 약과 영양제를 제대로 보관하지 않으면 효과가 떨어질 수 있습니다. 여름철 약과 영양제를 안전하게 보관하는 방법 및 효과를 유지하고 건강을 지키는 꿀팁을 확인하세요.",
        summary:
          "여름철 약과 영양제, 제대로 보관하는 방법여름철 무더위가 기승을 부리는 시기에는 약과 영양제의 보관에 특별한 주의가 필요합니다. 높은 온도와 습도로 인해 약의 효능이 떨어지거나 변질될 위험이 있기 때문입니다. 여름철 약과 영양제를 안전하게 보관하는 방법을 알아보겠습니다. 올바른 보관법을 통해 약과 영양제의 효과를 최대한 유지하고, 건강을 지키는 ..",
        userId: 3993000,
        userName: "\uD83D\uDCBB유익한정보",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3282011/attach/d9e48cd323e34d1494d38179e8e194ca",
        categoryName: "건강",
        thumbnail:
          "https://k.kakaocdn.net/dn/UmtMS/btsHVyNuyXo/s6m2TsBiSAxp2E273wAGxK/img.png",
        link: "https://blog.rushmac.net/309",
        blogId: 3282011,
        blogTitle: "\uD83D\uDCBB 생활정보Blog",
        likeCount: 6,
        commentCount: 0,
        firstReactionCreated: 1718085796000,
        published: "2024.06.11 15:02",
        publishedAgo: "13분 전",
        supportCount: 0,
        encodedTitle:
          "%EC%97%AC%EB%A6%84%EC%B2%A0%EC%97%90%EB%8A%94%20%EC%95%BD%EA%B3%BC%20%EC%98%81%EC%96%91%EC%A0%9C%EB%A5%BC%20%EC%A0%9C%EB%8C%80%EB%A1%9C%20%EB%B3%B4%EA%B4%80%ED%95%98%EC%A7%80%20%EC%95%8A%EC%9C%BC%EB%A9%B4%20%ED%9A%A8%EA%B3%BC%EA%B0%80%20%EB%96%A8%EC%96%B4%EC%A7%88%20%EC%88%98%20%EC%9E%88%EC%8A%B5%EB%8B%88%EB%8B%A4.%20%EC%97%AC%EB%A6%84%EC%B2%A0%20%EC%95%BD%EA%B3%BC%20%EC%98%81%EC%96%91%EC%A0%9C%EB%A5%BC%20%EC%95%88%EC%A0%84%ED%95%98%EA%B2%8C%20%EB%B3%B4%EA%B4%80%ED%95%98%EB%8A%94%20%EB%B0%A9%EB%B2%95%20%EB%B0%8F%20%ED%9A%A8%EA%B3%BC%EB%A5%BC%20%EC%9C%A0%EC%A7%80%ED%95%98%EA%B3%A0%20%EA%B1%B4%EA%B0%95%EC%9D%84%20%EC%A7%80%ED%82%A4%EB%8A%94%20%EA%BF%80%ED%8C%81%EC%9D%84%20%ED%99%95%EC%9D%B8%ED%95%98%EC%84%B8%EC%9A%94.",
        encodedUserName:
          "%F0%9F%92%BB%EC%9C%A0%EC%9D%B5%ED%95%9C%EC%A0%95%EB%B3%B4",
      },
      {
        uniqueId: "6939734_247",
        title: "닭뼈 음식물 쓰레기인가? 일반 쓰레기인가?",
        summary:
          "닭뼈는 음식물 쓰레기로 분류해야 할지, 일반 쓰레기로 분류해야 할지 헷갈리는 경우가 많습니다. 닭뼈 음식물?일반? 바로가기 \uD83D\uDC48 클릭 이번 글에서는 닭뼈의 정확한 분류 기준과 처리 방법에 대해 자세히 알아보겠습니다. 자세한 내용은 아래에서 함께 알아보도록 하겠습니다.  닭뼈 음식물 쓰레기인가? 일반 쓰레기인가? 닭뼈의 분류 기준음식물 쓰..",
        userId: 6592146,
        userName: "웅이 아버지!",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6939734/attach/a2325d9321c040e2ac8e06911ebd18bc",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/pKGyk/btsHUNxA7uq/l9lRtwQ9zsgDN5PiY12DuK/img.png",
        link: "https://w000ng.tistory.com/entry/닭뼈-음식물-쓰레기-일반-쓰레기",
        blogId: 6939734,
        blogTitle: "웅이 아버지!",
        likeCount: 5,
        commentCount: 0,
        firstReactionCreated: 1718085756000,
        published: "2024.06.11 15:02",
        publishedAgo: "14분 전",
        supportCount: 0,
        encodedTitle:
          "%EB%8B%AD%EB%BC%88%20%EC%9D%8C%EC%8B%9D%EB%AC%BC%20%EC%93%B0%EB%A0%88%EA%B8%B0%EC%9D%B8%EA%B0%80%3F%20%EC%9D%BC%EB%B0%98%20%EC%93%B0%EB%A0%88%EA%B8%B0%EC%9D%B8%EA%B0%80%3F",
        encodedUserName: "%EC%9B%85%EC%9D%B4%20%EC%95%84%EB%B2%84%EC%A7%80%21",
      },
      {
        uniqueId: "6373162_273",
        title: "6월 7일 스피또 출고율 및 당첨 복권 남은 수량",
        summary:
          "스피또 출고현황, 출고율, 현재 당첨 복권 남은 수량! 출고율 71%라는 스피또 1000 2천만원 당첨 복권 남은 수량이 38매라고? 오! 2천만원 내꺼^^5장 구매1,000원 됐다! 물론 한장 바로 바꿔서 긁으니 꽝^^ 어차피 안될거 로또 사서 토요일까지 기대감이나 갖고 있을 걸ㅋㅋㅋㅋㅋ 허무",
        userId: 6211777,
        userName: "해피지여니",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6373162/attach/04be941e85cf498ba1415215eaae5b61",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/SvxWR/btsHVcjzbWa/HzF746Zkan7kRCkWeMxOVk/img.jpg",
        link: "https://happy-jy.com/273",
        blogId: 6373162,
        blogTitle: "해피지여니의 일상, 생각, 리뷰",
        likeCount: 10,
        commentCount: 4,
        firstReactionCreated: 1718085135000,
        published: "2024.06.11 14:52",
        publishedAgo: "24분 전",
        supportCount: 0,
        encodedTitle:
          "6%EC%9B%94%207%EC%9D%BC%20%EC%8A%A4%ED%94%BC%EB%98%90%20%EC%B6%9C%EA%B3%A0%EC%9C%A8%20%EB%B0%8F%20%EB%8B%B9%EC%B2%A8%20%EB%B3%B5%EA%B6%8C%20%EB%82%A8%EC%9D%80%20%EC%88%98%EB%9F%89",
        encodedUserName: "%ED%95%B4%ED%94%BC%EC%A7%80%EC%97%AC%EB%8B%88",
      },
      {
        uniqueId: "6316567_286",
        title: "‘2026여수세계섬박람회 성공개최를 위하여...",
        summary:
          "‘2026여수세계섬박람회’ 성공 개최를 위하여...□ 오는 2026년 9월, 여수에서 세계 최초로 섬을 주제로 한 국제박람회가 열린다. ○ 2026여수세계섬박람회(섬박람회)는 섬을 가진 국가들이 모여 섬의 역사와 문화를 공유하고, 보존과 개발의 조화를 통해 섬의 발전 청사진을 제시하기 위해 마련됐다. ○ 2021년 기획재정부의 국제행사 승인을 시작으로 2022년에는..",
        userId: 6169450,
        userName: "아꿈사",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6316567/attach/182797057c13416b8020e6723796811f",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/viVRV/btsHVW1iA8D/UnpStzWbEn97qQoEB4J4h0/img.png",
        link: "https://aggumsa.tistory.com/286",
        blogId: 6316567,
        blogTitle: "aggumsa",
        likeCount: 10,
        commentCount: 8,
        firstReactionCreated: 1718084971000,
        published: "2024.06.11 14:32",
        publishedAgo: "43분 전",
        supportCount: 0,
        encodedTitle:
          "%E2%80%982026%EC%97%AC%EC%88%98%EC%84%B8%EA%B3%84%EC%84%AC%EB%B0%95%EB%9E%8C%ED%9A%8C%20%EC%84%B1%EA%B3%B5%EA%B0%9C%EC%B5%9C%EB%A5%BC%20%EC%9C%84%ED%95%98%EC%97%AC...",
        encodedUserName: "%EC%95%84%EA%BF%88%EC%82%AC",
      },
      {
        uniqueId: "6706238_41",
        title: "서현 다이어트 제품 콜레올로지 빨간물 빨간통 다이어트",
        summary:
          "서현 다이어트 제품 콜레올로지 빨간물 빨간통 다이어트다이어트를 결심하셨나요? 수많은 다이어트 방법 중 어느 것이 가장 효과적일지 고민이시죠? 그렇다면 다이어트와 관련된 모든 문제를 해결해줄 '서현 다이어트' '신봉선 다이어트'에 대해 알아보세요. 바로 '콜레올로지 티'와 '콜레올로지 컷'입니다. 콜레올로지 티는 다이어트 보조제 이면서  체지방 감소, ..",
        userId: 4716543,
        userName: "건강스토리",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6706238/attach/21884b35479b46f8ae9978350fabe184",
        categoryName: "건강",
        thumbnail:
          "https://k.kakaocdn.net/dn/nrmsM/btsHUxuLyp4/2WMp8YC8xVclqs4hTuUyx1/img.png",
        link: "https://health.wellnessprimary.com/entry/서현-다이어트",
        blogId: 6706238,
        blogTitle: "웰빙라이프 매거진",
        likeCount: 5,
        commentCount: 2,
        firstReactionCreated: 1718084905000,
        published: "2024.06.11 13:10",
        publishedAgo: "2시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%84%9C%ED%98%84%20%EB%8B%A4%EC%9D%B4%EC%96%B4%ED%8A%B8%20%EC%A0%9C%ED%92%88%20%EC%BD%9C%EB%A0%88%EC%98%AC%EB%A1%9C%EC%A7%80%20%EB%B9%A8%EA%B0%84%EB%AC%BC%20%EB%B9%A8%EA%B0%84%ED%86%B5%20%EB%8B%A4%EC%9D%B4%EC%96%B4%ED%8A%B8",
        encodedUserName: "%EA%B1%B4%EA%B0%95%EC%8A%A4%ED%86%A0%EB%A6%AC",
      },
      {
        uniqueId: "6939734_246",
        title: "수전증 원인 및 치료법, 관리 방법 알아보기",
        summary:
          "수전증은 손이 떨리는 증상으로, 일상 생활에 큰 불편을 초래할 수 있습니다. 수전증 원인 바로가기 \uD83D\uDC48 클릭 이번 글에서는 수전증의 원인, 치료법, 관리 방법에 대해 자세히 알아보겠습니다. 자세한 내용은 아래에서 함께 알아보도록 하겠습니다.  수전증 원인 및 치료법, 관리 방법 알아보기 수전증이란?수전증의 정의수전증은 의도치 않게 손이나 팔..",
        userId: 6592146,
        userName: "웅이 아버지!",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6939734/attach/a2325d9321c040e2ac8e06911ebd18bc",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/beiZ9u/btsHU7CymmI/aKXFDpPz2M17qDpvHGHC0k/img.png",
        link: "https://w000ng.tistory.com/entry/수전증-원인-치료법",
        blogId: 6939734,
        blogTitle: "웅이 아버지!",
        likeCount: 5,
        commentCount: 1,
        firstReactionCreated: 1718084879000,
        published: "2024.06.11 14:47",
        publishedAgo: "28분 전",
        supportCount: 0,
        encodedTitle:
          "%EC%88%98%EC%A0%84%EC%A6%9D%20%EC%9B%90%EC%9D%B8%20%EB%B0%8F%20%EC%B9%98%EB%A3%8C%EB%B2%95%2C%20%EA%B4%80%EB%A6%AC%20%EB%B0%A9%EB%B2%95%20%EC%95%8C%EC%95%84%EB%B3%B4%EA%B8%B0",
        encodedUserName: "%EC%9B%85%EC%9D%B4%20%EC%95%84%EB%B2%84%EC%A7%80%21",
      },
      {
        uniqueId: "5448919_12850525",
        title: "울릉도 세바퀴 그리고 독도",
        summary:
          "울릉도 세바퀴 그리고 독도 아름다운 나라감사함을 가져야 할 나라대한민국 그 대한민국은울릉도를 가진 나라독도를 가진 나라 그 나라의 한사람으로두 번 째 울릉도와 독도 방문 울릉도 세 바퀴승용차로 한바퀴달리기로 한바퀴유람선으로 또 한바퀴 속속 들어온 울릉도이 아름다운 땅이대한민국이라는 것에 자랑스럽다. 가슴 뭉쿨한 울릉도와 독도감동 ..",
        userId: 5453506,
        userName: "부르스 리(이판사)",
        userImage:
          "https://tistory1.daumcdn.net/tistory/5448919/attach/3cbeea9b3d314097b054ed7793c3cd00",
        categoryName: "일상다반사",
        thumbnail:
          "https://k.kakaocdn.net/dn/edexWQ/btsHTnzRXqg/yBGfYa5kybfQxxGr3Tnt20/img.jpg",
        link: "https://kwanbok1.tistory.com/entry/울릉도-세바퀴-그리고-독도",
        blogId: 5448919,
        blogTitle: "부르스리의 소확행 <學/愛/走/農 - 더불어 행복한 삶>",
        likeCount: 5,
        commentCount: 6,
        firstReactionCreated: 1718084319000,
        published: "2024.06.11 13:57",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EC%9A%B8%EB%A6%89%EB%8F%84%20%EC%84%B8%EB%B0%94%ED%80%B4%20%EA%B7%B8%EB%A6%AC%EA%B3%A0%20%EB%8F%85%EB%8F%84",
        encodedUserName:
          "%EB%B6%80%EB%A5%B4%EC%8A%A4%20%EB%A6%AC%28%EC%9D%B4%ED%8C%90%EC%82%AC%29",
      },
      {
        uniqueId: "6939734_245",
        title: "망고 보관법 후숙해서 보관하기",
        summary:
          "망고는 전 세계적으로 사랑받는 과일 중 하나입니다. 달콤하고 상큼한 맛으로 다양한 요리에 사용되며, 영양가가 높아 건강에도 좋습니다. 그러나 망고는 잘못 보관하면 쉽게 상할 수 있습니다. 망고 보관법 바로가기 \uD83D\uDC48 클릭 이번 글에서는 망고를 후숙시키고 보관하는 방법에 대해 자세히 알아보겠습니다. 자세한 내용은 아래에서 함께 알아보도록 ..",
        userId: 6592146,
        userName: "웅이 아버지!",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6939734/attach/a2325d9321c040e2ac8e06911ebd18bc",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/c6AXvl/btsHTViXNXL/kAuRvUF0pCj4kOOe3AnyVK/img.png",
        link: "https://w000ng.tistory.com/entry/망고-보관법-후숙",
        blogId: 6939734,
        blogTitle: "웅이 아버지!",
        likeCount: 6,
        commentCount: 2,
        firstReactionCreated: 1718083596000,
        published: "2024.06.11 14:26",
        publishedAgo: "50분 전",
        supportCount: 0,
        encodedTitle:
          "%EB%A7%9D%EA%B3%A0%20%EB%B3%B4%EA%B4%80%EB%B2%95%20%ED%9B%84%EC%88%99%ED%95%B4%EC%84%9C%20%EB%B3%B4%EA%B4%80%ED%95%98%EA%B8%B0",
        encodedUserName: "%EC%9B%85%EC%9D%B4%20%EC%95%84%EB%B2%84%EC%A7%80%21",
      },
      {
        uniqueId: "6939734_244",
        title: "망고와 애플망고 무엇이 다른가요?",
        summary:
          "망고는 전 세계적으로 사랑받는 열대 과일 중 하나입니다. 망고 중에서도 특히 애플망고는 그 맛과 식감으로 인기가 많습니다. 망고와 애플망고 차이점 바로가기 \uD83D\uDC48 클릭 이 글에서는 망고와 애플망고의 차이점, 특징, 영양성분, 맛의 차이, 그리고 각각의 활용 방법에 대해 자세히 알아보겠습니다. 자세한 내용은 아래에서 함께 알아보도록 하겠습니다..",
        userId: 6592146,
        userName: "웅이 아버지!",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6939734/attach/a2325d9321c040e2ac8e06911ebd18bc",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/bOOWjH/btsHVu5eL1y/pchlOrteG4U3mKzeIIzaYk/img.png",
        link: "https://w000ng.tistory.com/entry/망고-애플망고-차이",
        blogId: 6939734,
        blogTitle: "웅이 아버지!",
        likeCount: 6,
        commentCount: 2,
        firstReactionCreated: 1718082995000,
        published: "2024.06.11 14:16",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%A7%9D%EA%B3%A0%EC%99%80%20%EC%95%A0%ED%94%8C%EB%A7%9D%EA%B3%A0%20%EB%AC%B4%EC%97%87%EC%9D%B4%20%EB%8B%A4%EB%A5%B8%EA%B0%80%EC%9A%94%3F",
        encodedUserName: "%EC%9B%85%EC%9D%B4%20%EC%95%84%EB%B2%84%EC%A7%80%21",
      },
      {
        uniqueId: "6939734_243",
        title: "밥지을때 소주 넣으면?",
        summary:
          "밥을 짓는 과정에서 소주를 넣는 것은 오래된 요리 비법 중 하나로, 많은 사람들이 이 방법을 통해 밥의 맛과 식감을 더욱 좋게 만들고자 합니다. 밥지을때 소주 넣으면? 바로가기\uD83D\uDC48 클릭 이번 글에서는 밥을 지을 때 소주를 넣는 이유, 그 효과, 그리고 정확한 사용법에 대해 알아보겠습니다. 자세한 내용은 아래에서 함께 알아보도록 하겠습니다.  밥..",
        userId: 6592146,
        userName: "웅이 아버지!",
        userImage:
          "https://tistory1.daumcdn.net/tistory/6939734/attach/a2325d9321c040e2ac8e06911ebd18bc",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/Yqnvz/btsHUatktIT/tgHUekkrLpvUhD7ddvGyRK/img.png",
        link: "https://w000ng.tistory.com/entry/밥지을때-소주",
        blogId: 6939734,
        blogTitle: "웅이 아버지!",
        likeCount: 6,
        commentCount: 2,
        firstReactionCreated: 1718082225000,
        published: "2024.06.11 14:03",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%B0%A5%EC%A7%80%EC%9D%84%EB%95%8C%20%EC%86%8C%EC%A3%BC%20%EB%84%A3%EC%9C%BC%EB%A9%B4%3F",
        encodedUserName: "%EC%9B%85%EC%9D%B4%20%EC%95%84%EB%B2%84%EC%A7%80%21",
      },
      {
        uniqueId: "3793053_811",
        title:
          "[인테리어젠틀맨] 10평 양주 UNU헤어 깔끔한 스타일의 1인미용실인테리어",
        summary:
          "10평 양주 UNU헤어 깔끔한 스타일의 1인미용실인테리어 오늘 소개해 드릴 1인미용실인테리어 시공 사례는화이트&아이보리 톤을 사용한디자인을 원하셨던 고객님의 니즈에 맞춰전체적으로 깔끔하면서도화사함이 느껴질 수 있도록 연출해 드렸는데요. 먼저 외부파사드부터 자세히 살펴보겠습니다 : )입체감이 느껴지는고정식 어닝간판을 달아 시인성을..",
        userId: 4305786,
        userName: "인테리어젠틀맨",
        userImage:
          "https://tistory1.daumcdn.net/tistory/3793053/attach/71b06a83251d4ad0b724420d51cfc97a",
        categoryName: "인테리어",
        thumbnail:
          "https://k.kakaocdn.net/dn/2pqXK/btsHDzNNPhm/pyZIuKiZsKzaobl08K8BWk/img.jpg",
        link: "https://interiorgentleman.tistory.com/811",
        blogId: 3793053,
        blogTitle: "인테리어젠틀맨",
        likeCount: 6,
        commentCount: 6,
        firstReactionCreated: 1718082157000,
        published: "2024.06.11 14:02",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%5B%EC%9D%B8%ED%85%8C%EB%A6%AC%EC%96%B4%EC%A0%A0%ED%8B%80%EB%A7%A8%5D%2010%ED%8F%89%20%EC%96%91%EC%A3%BC%20UNU%ED%97%A4%EC%96%B4%20%EA%B9%94%EB%81%94%ED%95%9C%20%EC%8A%A4%ED%83%80%EC%9D%BC%EC%9D%98%201%EC%9D%B8%EB%AF%B8%EC%9A%A9%EC%8B%A4%EC%9D%B8%ED%85%8C%EB%A6%AC%EC%96%B4",
        encodedUserName:
          "%EC%9D%B8%ED%85%8C%EB%A6%AC%EC%96%B4%EC%A0%A0%ED%8B%80%EB%A7%A8",
      },
      {
        uniqueId: "2937126_225",
        title: "디지털 관광주민증 발급 방법(총정리)",
        summary:
          "요즘 핫한 디지털 관광주민증에 대해 더 자세히 알아보려고 해요. 저도 얼마 전에 발급받았는데, 생각보다 너무 쉽고 혜택도 많아서 깜짝 놀랐답니다. 지금부터 저랑 같이 디지털 관광주민증 발급 방법, 혜택, 대상 지역 등에 대해 자세히 알아봅시다.1. 디지털 관광주민증, 도대체 뭐야?\uD83E\uDD14 디지털 관광주민증은 말 그대로 디지털로 발급되는 명예 주민증이에요. ..",
        userId: 3771117,
        userName: "오나오나나",
        userImage:
          "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        categoryName: "생활정보",
        thumbnail:
          "https://k.kakaocdn.net/dn/5dMlt/btsHU8acgEv/KU6ILjCKnIIPF5g2TeBqmK/img.jpg",
        link: "https://dealbom.com/entry/디지털-관광주민증-발급-방법총정리",
        blogId: 2937126,
        blogTitle: "실시간 인기글",
        likeCount: 9,
        commentCount: 4,
        firstReactionCreated: 1718081932000,
        published: "2024.06.11 13:58",
        publishedAgo: "1시간 전",
        supportCount: 0,
        encodedTitle:
          "%EB%94%94%EC%A7%80%ED%84%B8%20%EA%B4%80%EA%B4%91%EC%A3%BC%EB%AF%BC%EC%A6%9D%20%EB%B0%9C%EA%B8%89%20%EB%B0%A9%EB%B2%95%28%EC%B4%9D%EC%A0%95%EB%A6%AC%29",
        encodedUserName: "%EC%98%A4%EB%82%98%EC%98%A4%EB%82%98%EB%82%98",
      },
    ],
    category: "life",
    hasNext: true,
  },
};

export const dummyItemLife2 ={
  "error": false,
  "data": {
    "lastPublished": 1718883122000,
    "list": [
      {
        "uniqueId": "7025522_6",
        "title": "6월에 먹었던 음식 중 가장 맛있게 배불리 맘 편하게 먹었던 음식은?",
        "summary": "\"\"샤브몰\"\" 원주점에서월남쌈소고기무한리필을 먹었습니다~^^너무 맛있고 무한리필이다 보니 정말 배불리 먹었고돈 걱정 없이 편하게 맘껏 먹었습니다~",
        "userId": 6645034,
        "userName": "온유인내",
        "userImage": "https://t1.daumcdn.net/tistory_admin/static/manage/images/r3/default_S.png",
        "categoryName": "요리",
        "thumbnail": "https://k.kakaocdn.net/dn/bHsd4B/btsH6MLVmEd/hakk7kFKUPsPtZRI3upSt1/img.jpg",
        "link": "https://tkfkd25.tistory.com/6",
        "blogId": 7025522,
        "blogTitle": "사랑바라기",
        "likeCount": 6,
        "commentCount": 8,
        "firstReactionCreated": 1718889292000,
        "published": "2024.06.20 22:00",
        "publishedAgo": "46분 전",
        "supportCount": 0,
        "encodedTitle": "6%EC%9B%94%EC%97%90%20%EB%A8%B9%EC%97%88%EB%8D%98%20%EC%9D%8C%EC%8B%9D%20%EC%A4%91%20%EA%B0%80%EC%9E%A5%20%EB%A7%9B%EC%9E%88%EA%B2%8C%20%EB%B0%B0%EB%B6%88%EB%A6%AC%20%EB%A7%98%20%ED%8E%B8%ED%95%98%EA%B2%8C%20%EB%A8%B9%EC%97%88%EB%8D%98%20%EC%9D%8C%EC%8B%9D%EC%9D%80%3F",
        "encodedUserName": "%EC%98%A8%EC%9C%A0%EC%9D%B8%EB%82%B4"
      },
      {
        "uniqueId": "7023301_7",
        "title": "봉포 머구리 물회 /  전복물회 모듬물회  / 속초맛집",
        "summary": "더위가 일찍 찾아왔습니다. 오늘은 아침부터 푹푹 찌는 듯합니다. 아직 이렇게 더우면 안 되는데...  올해는 많이 덥다고 하는데 걱정입니다.     오늘처럼 더운 날엔 입맛도 없고 시원한 걸 찾게 됩니다. 그래서 오늘은 물회를 소개합니다~ 속초 봉포 머구리 물회입니다.     맛집이라고 소문도 나고 제대로 된 물회를 먹어보기 위해 속초로 달..",
        "userId": 6643547,
        "userName": "새벽별소리",
        "userImage": "https://tistory1.daumcdn.net/tistory/7023301/attach/95edf77b6c6c44d7a3dca0c094801805",
        "categoryName": "요리",
        "thumbnail": "https://k.kakaocdn.net/dn/cuoJjj/btsH6vKkoST/Q67epBPMCxtMScS4FrHVmK/img.jpg",
        "link": "https://seon56429.tistory.com/7",
        "blogId": 7023301,
        "blogTitle": "새벽별소리와 별들의 속삭임",
        "likeCount": 6,
        "commentCount": 14,
        "firstReactionCreated": 1718889128000,
        "published": "2024.06.20 22:06",
        "publishedAgo": "39분 전",
        "supportCount": 0,
        "encodedTitle": "%EB%B4%89%ED%8F%AC%20%EB%A8%B8%EA%B5%AC%EB%A6%AC%20%EB%AC%BC%ED%9A%8C%20%2F%20%20%EC%A0%84%EB%B3%B5%EB%AC%BC%ED%9A%8C%20%EB%AA%A8%EB%93%AC%EB%AC%BC%ED%9A%8C%20%20%2F%20%EC%86%8D%EC%B4%88%EB%A7%9B%EC%A7%91",
        "encodedUserName": "%EC%83%88%EB%B2%BD%EB%B3%84%EC%86%8C%EB%A6%AC"
      },
      {
        "uniqueId": "5689538_1717",
        "title": "아침에 다녀왔던 부천88성모정형외과와 부천북부역 마루광장에서 열린 2024년 부천시 효사랑 장애인 합동 고희잔치 풍경(2024년 6월 20일)",
        "summary": "신한국 황대장입니다. 오늘 하루도 벌써 다 지나갔네요. 오늘도 하루종일 찜통더위가 아주 기승을 부렸네요. 게다가 요즘에는 찜통더위만  문제가 아니라 제가 일하는 매장에 벌레들이 계속해서 들어온다는 것이죠. 오늘만도 잡은 벌레들만 무려 수십마리나 될 정도이니 말 다했죠 ㄷㄷㄷㄷ 그럼 오늘은 아침에 ..",
        "userId": 5651823,
        "userName": "황 대장",
        "userImage": "https://tistory1.daumcdn.net/tistory/5689538/attach/783d5582ab6248e2b05b9f6fcfe2e6f7",
        "categoryName": "일상다반사",
        "thumbnail": "https://k.kakaocdn.net/dn/bL0mPU/btsH5O42hZo/VjtfjJqkAdBZrxO5g8sxzk/img.jpg",
        "link": "https://tecmo17.tistory.com/entry/아침에-다녀왔던-부천88성모정형외과와-부천북부역-마루광장에서-열린-2024년-부천시-효사랑-장애인-합동-고희잔치-풍경2024년-6월-20일",
        "blogId": 5689538,
        "blogTitle": "신한국 황대장",
        "likeCount": 13,
        "commentCount": 13,
        "firstReactionCreated": 1718888452000,
        "published": "2024.06.20 21:58",
        "publishedAgo": "48분 전",
        "supportCount": 0,
        "encodedTitle": "%EC%95%84%EC%B9%A8%EC%97%90%20%EB%8B%A4%EB%85%80%EC%99%94%EB%8D%98%20%EB%B6%80%EC%B2%9C88%EC%84%B1%EB%AA%A8%EC%A0%95%ED%98%95%EC%99%B8%EA%B3%BC%EC%99%80%20%EB%B6%80%EC%B2%9C%EB%B6%81%EB%B6%80%EC%97%AD%20%EB%A7%88%EB%A3%A8%EA%B4%91%EC%9E%A5%EC%97%90%EC%84%9C%20%EC%97%B4%EB%A6%B0%202024%EB%85%84%20%EB%B6%80%EC%B2%9C%EC%8B%9C%20%ED%9A%A8%EC%82%AC%EB%9E%91%20%EC%9E%A5%EC%95%A0%EC%9D%B8%20%ED%95%A9%EB%8F%99%20%EA%B3%A0%ED%9D%AC%EC%9E%94%EC%B9%98%20%ED%92%8D%EA%B2%BD%282024%EB%85%84%206%EC%9B%94%2020%EC%9D%BC%29",
        "encodedUserName": "%ED%99%A9%20%EB%8C%80%EC%9E%A5"
      },
      {
        "uniqueId": "7050550_39",
        "title": "만성피로 해결하는 10가지 방법",
        "summary": "만성피로 해결하는 10가지 방법요즘 바쁜 일상 속에서 만성피로에 시달리시는 분들 많으시죠? 저도 그랬어요. 하지만 몇 가지 방법을 통해 꾸준히 관리하다 보니 훨씬 나아졌답니다. 그래서 오늘은 제가 직접 경험하고 효과를 본 만성피로 해결 방법 10가지를 여러분과 공유하려고 해요! 수면의 질 개선하기만성적인 피로를 겪고 있다면 수면의 질을 개선하는 것이..",
        "userId": 6661546,
        "userName": "온나이리",
        "userImage": "https://tistory1.daumcdn.net/tistory/7050550/attach/c7c20036b5774769b855956249dc75b6",
        "categoryName": "건강",
        "thumbnail": "https://k.kakaocdn.net/dn/b15K0v/btsH5lA8DFr/Z3B7NbTciJBL8ak3eh9te0/img.png",
        "link": "https://onna0304.tistory.com/entry/만성피로-해결하는-10가지-방법",
        "blogId": 7050550,
        "blogTitle": "다둥이집의 이모저모",
        "likeCount": 5,
        "commentCount": 5,
        "firstReactionCreated": 1718888225000,
        "published": "2024.06.20 21:56",
        "publishedAgo": "49분 전",
        "supportCount": 0,
        "encodedTitle": "%EB%A7%8C%EC%84%B1%ED%94%BC%EB%A1%9C%20%ED%95%B4%EA%B2%B0%ED%95%98%EB%8A%94%2010%EA%B0%80%EC%A7%80%20%EB%B0%A9%EB%B2%95",
        "encodedUserName": "%EC%98%A8%EB%82%98%EC%9D%B4%EB%A6%AC"
      },
      {
        "uniqueId": "6979479_69",
        "title": "돼지꿈 해몽 풀이",
        "summary": "돼지꿈의 기본 해석 방법꿈풀이에서 돼지는 재물, 행운, 복 등을 상징하는 길몽으로 여겨집니다. 돼지꿈은 꾸는 사람의 상황에 따라 다양한 의미로 해석될 수 있지만, 일반적으로 다음과 같은 의미를 가지고 있습니다. 1.재물과 행운: 돼지꿈은 재물과 부를 상징하며, 꿈에서 돼지를 보거나 돼지를 얻는다면 재물운이 상승하고 행운이 찾아올 것을 암시합니다. 복권..",
        "userId": 6616043,
        "userName": "하마입",
        "userImage": "https://tistory1.daumcdn.net/tistory/6979479/attach/f17757ac3ab34e8c83cdc7bc33b251fe",
        "categoryName": "일상다반사",
        "thumbnail": null,
        "link": "https://dbswls81.tistory.com/entry/돼지꿈-해몽-풀이",
        "blogId": 6979479,
        "blogTitle": "봄이 온다!!",
        "likeCount": 5,
        "commentCount": 5,
        "firstReactionCreated": 1718887697000,
        "published": "2024.06.20 20:54",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%8F%BC%EC%A7%80%EA%BF%88%20%ED%95%B4%EB%AA%BD%20%ED%92%80%EC%9D%B4",
        "encodedUserName": "%ED%95%98%EB%A7%88%EC%9E%85"
      },
      {
        "uniqueId": "6661511_269",
        "title": "마지막 집",
        "summary": "EBS다큐프라임에서 \"내 마지막 집은 어디인가\"를 보았다. 21세기 경제적 풍요가 일궈낸 인간 100세 시대. 노년의 삶에 대한 스토리다. 수명이 늘어날수록 축복이 아닌 고달픔만 연장된다. 요양시설보다 자신의 집에서 일상케어를 받는 재택요양서비스에 대한 논의도 현실적으로 다루어졌다. 빈부격차에 따라 노인의 삶은 더욱 극명하게 엇갈린다. 경제적 여유가 있..",
        "userId": 6419803,
        "userName": "최포근",
        "userImage": "https://tistory1.daumcdn.net/tistory/6661511/attach/b0d6065e6a3f42d4af7ade4b265b871a",
        "categoryName": "일상다반사",
        "thumbnail": "https://k.kakaocdn.net/dn/b3TzsI/btsH7nx5N0Q/IYqzK3m8YQt8d0GwB5ZCY1/img.jpg",
        "link": "https://sol0003.tistory.com/269",
        "blogId": 6661511,
        "blogTitle": "치자꽃향기처럼",
        "likeCount": 11,
        "commentCount": 11,
        "firstReactionCreated": 1718887414000,
        "published": "2024.06.20 20:32",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EB%A7%88%EC%A7%80%EB%A7%89%20%EC%A7%91",
        "encodedUserName": "%EC%B5%9C%ED%8F%AC%EA%B7%BC"
      },
      {
        "uniqueId": "5783558_2580",
        "title": "How to Identify Potential Weight Gain: Do You Know the Cracker Test?",
        "summary": "Understanding your body type is crucial for maintaining a healthy lifestyle and diet. Different body types require different diets and exercise routines. Recently, Dr. Sharon Moalem, an American geneticist, proposed the \"Cracker Test\" as a simple method to determine your body type and how your body metabolizes carbohydrates. In this post, we'..",
        "userId": 5724429,
        "userName": "OK2BU",
        "userImage": "https://tistory1.daumcdn.net/tistory/5783558/attach/454b05efd192453e8eea96f1f6bffb48",
        "categoryName": "생활정보",
        "thumbnail": "https://k.kakaocdn.net/dn/cvMhOP/btsH6f7F5IT/qBQBEzLUVGsx1twtiAGtpk/img.png",
        "link": "https://ok2bu.tistory.com/2580",
        "blogId": 5783558,
        "blogTitle": "OK2BU",
        "likeCount": 8,
        "commentCount": 8,
        "firstReactionCreated": 1718886735000,
        "published": "2024.06.20 21:23",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "How%20to%20Identify%20Potential%20Weight%20Gain%3A%20Do%20You%20Know%20the%20Cracker%20Test%3F",
        "encodedUserName": "OK2BU"
      },
      {
        "uniqueId": "4372090_85",
        "title": "[생각의 기술] 한국을 떠나는 부자들: 고액 자산가 순유출 세계 4위",
        "summary": "최근 발표된 '2024년 헨리 개인자산 이주 보고서'에 따르면, 한국의 고액순자산보유자(HNWI)들이 급증하는 속도로 해외로 이주하고 있습니다. 한국은 올해 1,200명의 부자들이 순유출될 것으로 예상되며, 이는 세계에서 네 번째로 높은 수치입니다. 이는 지난해 7위에서 큰 폭으로 상승한 것입니다.  고액 자산가들의 유출 현황  보고서에 따르면, 한국의 고..",
        "userId": 4678017,
        "userName": "천상연인",
        "userImage": "https://tistory1.daumcdn.net/tistory/4372090/attach/b4e32afb50d94c3292e984b2947e3591",
        "categoryName": "일상다반사",
        "thumbnail": "https://k.kakaocdn.net/dn/vIotY/btsH5HSmGMi/rdYZtXe1196wspD9Q49jT0/img.webp",
        "link": "https://probaby.tistory.com/85",
        "blogId": 4372090,
        "blogTitle": "하준아빠의 인문학 이야기",
        "likeCount": 15,
        "commentCount": 19,
        "firstReactionCreated": 1718886637000,
        "published": "2024.06.20 21:28",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "%5B%EC%83%9D%EA%B0%81%EC%9D%98%20%EA%B8%B0%EC%88%A0%5D%20%ED%95%9C%EA%B5%AD%EC%9D%84%20%EB%96%A0%EB%82%98%EB%8A%94%20%EB%B6%80%EC%9E%90%EB%93%A4%3A%20%EA%B3%A0%EC%95%A1%20%EC%9E%90%EC%82%B0%EA%B0%80%20%EC%88%9C%EC%9C%A0%EC%B6%9C%20%EC%84%B8%EA%B3%84%204%EC%9C%84",
        "encodedUserName": "%EC%B2%9C%EC%83%81%EC%97%B0%EC%9D%B8"
      },
      {
        "uniqueId": "6650844_265",
        "title": "50대와 60대를 위한 필수 영양제를 소개!중장년층의 건강을 지키기 위해 꼭 필요한 비타민과 미네랄을 알아보세요.",
        "summary": "50대와 60대를 위한 건강 유지 비법: 꼭 먹어야 할 영양제나이가 들면서 우리 몸은 점차 변화하며, 이에 따라 필요한 영양소도 달라집니다. 특히 50대와 60대는 신체 기능이 약해지고, 면역력이 저하되기 쉬운 시기입니다. 이때 필요한 영양소를 충분히 섭취하는 것은 건강한 노년을 유지하는 데 매우 중요합니다. 하지만 음식만으로 모든 영양소를 충분히 섭취하기 ..",
        "userId": 3993000,
        "userName": "라이프이슈박스",
        "userImage": "https://tistory1.daumcdn.net/tistory/6650844/attach/ecca78d5b422462f85a56a1374f02ef7",
        "categoryName": "건강",
        "thumbnail": "https://k.kakaocdn.net/dn/b04Oti/btsH6O3QZN6/P1iJFUT8HH748TL3YFIHH1/img.png",
        "link": "https://issue.lifeinfobox.com/265",
        "blogId": 6650844,
        "blogTitle": "라이프 이슈 박스",
        "likeCount": 8,
        "commentCount": 3,
        "firstReactionCreated": 1718884330000,
        "published": "2024.06.20 21:33",
        "publishedAgo": "1시간 전",
        "supportCount": 0,
        "encodedTitle": "50%EB%8C%80%EC%99%80%2060%EB%8C%80%EB%A5%BC%20%EC%9C%84%ED%95%9C%20%ED%95%84%EC%88%98%20%EC%98%81%EC%96%91%EC%A0%9C%EB%A5%BC%20%EC%86%8C%EA%B0%9C%21%EC%A4%91%EC%9E%A5%EB%85%84%EC%B8%B5%EC%9D%98%20%EA%B1%B4%EA%B0%95%EC%9D%84%20%EC%A7%80%ED%82%A4%EA%B8%B0%20%EC%9C%84%ED%95%B4%20%EA%BC%AD%20%ED%95%84%EC%9A%94%ED%95%9C%20%EB%B9%84%ED%83%80%EB%AF%BC%EA%B3%BC%20%EB%AF%B8%EB%84%A4%EB%9E%84%EC%9D%84%20%EC%95%8C%EC%95%84%EB%B3%B4%EC%84%B8%EC%9A%94.",
        "encodedUserName": "%EB%9D%BC%EC%9D%B4%ED%94%84%EC%9D%B4%EC%8A%88%EB%B0%95%EC%8A%A4"
      },
      {
        "uniqueId": "5431214_27",
        "title": "[ 필름카메라 ] 롤라이 플렉스 3.5 mx",
        "summary": "기기 스펙생산 년도 : 1949년 ~ 1951년포맷 : 6x6 120mm 중형필름 (롤라이킨 사용시 35mm 필름 사용 가능)테이킹 렌즈 :Carl Zeiss Tessar 1:3.5 f=75mm, Coatedor : Zeiss Oberkochen Opton Tessar 1:3.5 f=75mm, Coated.or : Schneider-Kreuznach Xenar 1:3.5 f=75mm, Coated뷰잉 렌즈 : 1:2.8 f=75mm, coated필터 규격 : Bay 1사이즈 :  94 x 95 x 143 mm..",
        "userId": 5439615,
        "userName": "애기도현",
        "userImage": "https://tistory1.daumcdn.net/tistory/5431214/attach/728847c20e024c56b190843e0f4e90b6",
        "categoryName": "사진",
        "thumbnail": "https://k.kakaocdn.net/dn/biTpdj/btsG5uT2rJX/MJG04AJUQhtDhnQHkXkOx1/img.jpg",
        "link": "https://babyhyun.tistory.com/27",
        "blogId": 5431214,
        "blogTitle": "애기도현",
        "likeCount": 12,
        "commentCount": 8,
        "firstReactionCreated": 1718883827000,
        "published": "2024.06.20 20:41",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%5B%20%ED%95%84%EB%A6%84%EC%B9%B4%EB%A9%94%EB%9D%BC%20%5D%20%EB%A1%A4%EB%9D%BC%EC%9D%B4%20%ED%94%8C%EB%A0%89%EC%8A%A4%203.5%20mx",
        "encodedUserName": "%EC%95%A0%EA%B8%B0%EB%8F%84%ED%98%84"
      },
      {
        "uniqueId": "6990320_1932",
        "title": "주말 골프, 용인 아시아나 파3 골프장 추천! 예약 필수 | 수도권, 파3 골프장, 주말 골프, 가족 골프",
        "summary": "주말 골프, 용인 아시아나 파3 골프장 추천! 예약 필수 | 수도권, 파3 골프장, 주말 골프, 가족 골프주말, 가족과 함께 즐거운 시간을 보내고 싶다면 용인 아시아나 파3 골프장을 추천합니다!수도권에서 접근성이 뛰어나며, 파3 골프장으로 초보자도 부담 없이 즐길 수 있습니다. 아름다운 자연 속에서 가족 골프를 즐기며 잊지 못할 추억을 만들어보세요.용인 아시아..",
        "userId": 6621332,
        "userName": "뉴욕칼라티",
        "userImage": "https://tistory1.daumcdn.net/tistory/6990270/attach/c506c481547948efb042806e91dbeb90",
        "categoryName": "일상다반사",
        "thumbnail": "https://k.kakaocdn.net/dn/bc1IKe/btsH6xnJhm4/t587kO2sJh56GqXmKmLAcK/img.png",
        "link": "https://t9738748.tistory.com/entry/주말-골프-용인-아시아나-파3-골프장-추천-예약-필수-수도권-파3-골프장-주말-골프-가족-골프",
        "blogId": 6990320,
        "blogTitle": "푸른숲속에서",
        "likeCount": 5,
        "commentCount": 5,
        "firstReactionCreated": 1718883478000,
        "published": "2024.06.20 19:54",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%EC%A3%BC%EB%A7%90%20%EA%B3%A8%ED%94%84%2C%20%EC%9A%A9%EC%9D%B8%20%EC%95%84%EC%8B%9C%EC%95%84%EB%82%98%20%ED%8C%8C3%20%EA%B3%A8%ED%94%84%EC%9E%A5%20%EC%B6%94%EC%B2%9C%21%20%EC%98%88%EC%95%BD%20%ED%95%84%EC%88%98%20%7C%20%EC%88%98%EB%8F%84%EA%B6%8C%2C%20%ED%8C%8C3%20%EA%B3%A8%ED%94%84%EC%9E%A5%2C%20%EC%A3%BC%EB%A7%90%20%EA%B3%A8%ED%94%84%2C%20%EA%B0%80%EC%A1%B1%20%EA%B3%A8%ED%94%84",
        "encodedUserName": "%EB%89%B4%EC%9A%95%EC%B9%BC%EB%9D%BC%ED%8B%B0"
      },
      {
        "uniqueId": "6589758_572",
        "title": "큰 기회",
        "summary": "큰 기회는 쉽게 오지 않는다 큰 기회는 매일 사소한 기회를 잡은 사람에게 온다",
        "userId": 6371506,
        "userName": "integer1004",
        "userImage": "https://tistory1.daumcdn.net/tistory/6589758/attach/07f818f2541f40799f994df85f83dabf",
        "categoryName": "일상다반사",
        "thumbnail": "https://k.kakaocdn.net/dn/t2nFF/btsH61INC7R/pN4aP6gmMkotwJfKyTtqK1/img.jpg",
        "link": "https://integer1004.tistory.com/572",
        "blogId": 6589758,
        "blogTitle": "작은이야기",
        "likeCount": 17,
        "commentCount": 20,
        "firstReactionCreated": 1718883122000,
        "published": "2024.06.20 20:04",
        "publishedAgo": "2시간 전",
        "supportCount": 0,
        "encodedTitle": "%ED%81%B0%20%EA%B8%B0%ED%9A%8C",
        "encodedUserName": "integer1004"
      }
    ],
    "category": "life",
    "hasNext": true
  }
}
